/*!
 * Copyright © 2018-2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { GoogleMapsShapeUtils } from '../../../utils/google-maps-shapes.utils';
import { GoogleMapsShape } from '../../maps/models';
import { EMarkerShapeType } from './marker-shape-type.enum';
import { IMarkerShape } from './marker-shape.interface';

export class MarkerShape {
  constructor(public shape: IMarkerShape) {}

  public toGoogleMapShape(): GoogleMapsShape {
    let shape: GoogleMapsShape = null;
    switch (this.shape.shapeType) {
      case EMarkerShapeType.Circle: {
        shape = new google.maps.Circle({
          fillColor: this.shape.shapeColor,
          fillOpacity: 0.45,
          strokeColor: this.shape.shapeColor,
          strokeWeight: 2,
          center: this.shape.center,
          editable: false,
          radius: this.shape.radius,
          draggable: false
        });
        break;
      }
      case EMarkerShapeType.Rectangle: {
        shape = new google.maps.Rectangle({
          bounds: GoogleMapsShapeUtils.getBoundsFromShape(new google.maps.Polygon({ paths: this.shape.shapes })),
          strokeColor: this.shape.shapeColor,
          strokeWeight: 2,
          fillColor: this.shape.shapeColor,
          fillOpacity: 0.45
        });
        break;
      }
      case EMarkerShapeType.Polygon: {
        shape = new google.maps.Polygon({
          paths: this.shape.shapes,
          strokeColor: this.shape.shapeColor,
          strokeWeight: 2,
          fillColor: this.shape.shapeColor,
          fillOpacity: 0.45
        });
        break;
      }
    }
    return shape;
  }
}
